import { useContext } from 'react';

import { FeatureFlagContext } from '@/providers/FeatureFlagsProvider/FeatureFlagProvider';
import { Flags } from '@/providers/FeatureFlagsProvider/type';

/**
 * Hook for getting feature flag value
 * @param flagName - feature flag name
 * @returns boolean
 * @example
 * const isLightDarkMode = useFeatureFlag('lightDarkMode');
 */
export const useFeatureFlag = (flagName: keyof Flags | string) => {
  const flags = useContext(FeatureFlagContext);

  return !!flags[flagName];
};
